<div class="modal-header">
  <h3 class="modal-title">Add payment method</h3>
  <button type="button" class="btn-close" aria-label="Close" (click)="close()" [disabled]="submitted"></button>
</div>

<div class="modal-body">
  <form id="form" (ngSubmit)="submit()" ngNativeValidate>
    <app-payment-form [paypalInstructions]="'Submit'" (onPaymentFormValid)="onPaymentValid($event)" [companyId]="companyId"/>
  </form>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-secondary" (click)="close()" [disabled]="submitted">Cancel</button>
  <button type="submit" class="btn btn-primary" form="form" [disabled]="submitted">
    <span>Submit</span>
    <span *ngIf="submitted" class="spinner-border spinner-border-sm ms-2"></span>
  </button>
</div>

